/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { string, object } from "prop-types";
import classNames from "classnames/bind";
import merge from "lodash.mergewith";
import { Icon } from "../../../components/Icons";
import { Heading } from "../../../components/Headings/Heading";
import { RCL } from "../../../components/RCL";

import * as sharedStyles from "./SocialFollowButtonsCTA.module.scss";

/* eslint-disable react/jsx-no-target-blank */

let cx = classNames.bind(sharedStyles);

const SocialFollowButtonsCTA = ({
	ctaTitle,
	facebookPageLink,
	instagramPageLink,
	twitterPageLink,
	pinterestPageLink,
	youTubePageLink,
	styles,
}) => {
	cx = classNames.bind(merge(sharedStyles, styles));

	return (
		<div className={cx("SocialFollowButtonsCtaContainer", "SocialFollowButtonsCtaContainerCustom")}>
			<Heading as="h2" size="base" className={cx("socialCtaHeader", "socialCtaHeaderCustom")}>
				{ctaTitle}
			</Heading>
			<div className={cx("followLinks", "followLinksCustom")}>
				{facebookPageLink && (
					<a
						href={facebookPageLink}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"facebook",
							"facebookCustom"
						)}>
						<span className="sr-only">
							<RCL searchKey="connect-with-us-on-facebook" />
						</span>
						<Icon aria-hidden="true" name="facebook" />
					</a>
				)}

				{instagramPageLink && (
					<a
						href={instagramPageLink}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"instagram",
							"instagramCustom"
						)}>
						<span className="sr-only">
							<RCL searchKey="connect-with-us-on-instagram" />
						</span>
						<Icon aria-hidden="true" name="instagram" />
					</a>
				)}

				{twitterPageLink && (
					<a
						href={twitterPageLink}
						target="_blank"
						className={cx("socialMediaLink", "socialMediaLinkCustom", "twitter", "twitterCustom")}>
						<span className="sr-only">
							<RCL searchKey="connect-with-us-on-twitter" />
						</span>
						<Icon aria-hidden="true" name="twitter" />
					</a>
				)}

				{pinterestPageLink && (
					<a
						href={pinterestPageLink}
						target="_blank"
						className={cx(
							"socialMediaLink",
							"socialMediaLinkCustom",
							"pinterest",
							"pinterestCustom"
						)}>
						<span className="sr-only">
							<RCL searchKey="connect-with-us-on-pinterest" />
						</span>
						<Icon aria-hidden="true" name="pinterest" />
					</a>
				)}

				{youTubePageLink && (
					<a
						href={youTubePageLink}
						target="_blank"
						className={cx("socialMediaLink", "socialMediaLinkCustom", "youtube", "youtubeCustom")}>
						<span className="sr-only">
							<RCL searchKey="connect-with-us-on-youtube" />
						</span>
						<Icon aria-hidden="true" name="youtube" />
					</a>
				)}
			</div>
		</div>
	);
};

SocialFollowButtonsCTA.propTypes = {
	ctaTitle: string,
	facebookPageLink: string,
	instagramPageLink: string,
	twitterPageLink: string,
	pinterestPageLink: string,
	youTubePageLink: string,
	styles: object,
};
SocialFollowButtonsCTA.defaultProps = {
	ctaTitle: null,
	facebookPageLink: null,
	instagramPageLink: null,
	twitterPageLink: null,
	pinterestPageLink: null,
	youTubePageLink: null,
	styles: null,
};

export default SocialFollowButtonsCTA;
export { SocialFollowButtonsCTA };
